var _require = require('./send_panel.template'),
  buildSendPanelOverlay = _require.buildSendPanelOverlay;
module.exports = {
  saveOverlay: function saveOverlay(_ref) {
    var scriptDisplay = _ref.scriptDisplay;
    var formFieldsHtml = "\n      <div class=\"rs-save-later-copy\">\n        <p class=\"rs-save-later-lead\">Please download this file to save your script.</p>\n        <button type=\"button\" class=\"rs-btn rs-btn-primary rs-save-later-download\" data-action=\"save-later-download\">\n          Download Script\n        </button>\n        <p class=\"rs-save-later-note\">Select Import Saved Script on the main page to use it.</p>\n        <button type=\"button\" class=\"saito-text-link rs-save-later-home\" data-action=\"save-later-home\">\n          return to main page\n        </button>\n      </div>\n    ";
    return buildSendPanelOverlay({
      extraRootClass: 'rs-save-later',
      scriptDisplay: scriptDisplay,
      formFieldsHtml: formFieldsHtml,
      actionButtonHtml: ''
    });
  }
};